import Vue from 'vue'
import Vuex from 'vuex'

import login from './modules/auth/auth.module'
import nav from './modules/navigation/nav.module'
import user from './modules/user/user.module'
import users from './modules/user/users.module'
import userEmailNotificationPreference from './modules/user/notification-email-preference.module'
import role from './modules/role/role.module'
import trails from './modules/trails/trailsinfo.module'
import trailMovement from './modules/trails/trailmovement.module'
import trailDetails from './modules/trails/traildetails.module'
import trailGraph from './modules/trails/trailgraph.module'
import lateralmovements from './modules/trails/lateralmovement.module'
import trailSummary from './modules/trails/trailsummary.module'
import trailMigitation from './modules/trails/trailmitigation.module'
import privilegedtrail from './modules/trails/privilegedtrail.module'
import accountkeyProgressions from './modules/trails/accountkey-progressions.module'
import agents from './modules/agents/agents.module'
import accountKeyAgents from './modules/agents/accountkey-agents.module'
import rules from './modules/rules/rules.module'
import detections from './modules/detections/detections.module'
import traildetections from './modules/detections/traildetections.module'
import accountKeyDetections from './modules/detections/accountkey-detections.module'
import hostname from './modules/agents/hostname.module'
import signup from './modules/auth/signup.module'
import onboard from './modules/onboard/onboard.module'
import networkInfo from './modules/network_info/network-info.module'
import os from './modules/os_support/os-support.module'
import notification from './modules/notifications/notifications.module'
import statistics from './modules/statistics/statistics.module'
import insightStatistics from './modules/statistics/insight-statistics.module'
import dnsStatistics from './modules/statistics/dns-statistics.module'
import externalIpStatistics from './modules/statistics/external-ip-statistics.module'
import privilegedExecStatistics from './modules/statistics/privileged-execution-statistics.module'
import loginFailuresStatistics from './modules/statistics/login-failures-statistics.module'
import hostmapTopolopy from './modules/hostmap_info/hostmap_info.module'
import smtp from './modules/smtp/smtp-setting.module'
import slack from './modules/slack/slack-setting.module'
import columnPreference from './modules/column-preference/column-preference.module'
import slackNotify from './modules/user/notification-slack-preference.module'
import idp from './modules/idp/idp-setting.module'
import mitreAttack from './modules/mitre-attack/mitre-attack.module'
import processLineage from './modules/process_lineage/process-lineage.module'
import userPref from './modules/user_pref/user-pref.module'
import systemPref from './modules/system_pref/system-pref.module'
import threatHuntingQuerySearchFields from './modules/threat_hunting/query-fields.module'
import threatHuntingQuerySearch from './modules/threat_hunting/query-search.module'
import savedSearch from './modules/threat_hunting/saved-search.module'
import daterangePref from './modules/user_pref/daterange-pref.module'
import featureEnabled from './modules/feature_enabled/feature_enabled.module'
import dashboardKpi from './modules/dashboard/kpi-statistics.module'
import trailStatistics from './modules/dashboard/trail-statistics.module'
import version from './modules/version/version.module'
import eventsConsumed from './modules/agents/events-consumed.module'
import containerListInfo from './modules/agents/container-info.module'
import containerImagesList from './modules/agents/container-images.module'
import accountKeyContainers from './modules/agents/accountkey-containers.module'
import hostEventComposition from './modules/event_composition/event_composition.module'
import mostActive from './modules/statistics/most-active.module'
import trailsinfoFingerprint from './modules/trails/trailsinfo-fingerprint.module'
import allowlist from './modules/rules/allowlist.module'
import eventTypeValues from './modules/threat_hunting/eventtype-values.module'
import clouddiscovery from './modules/agents/cloud-discovery.module'
import kubernetesdiscovery from './modules/agents/kubernetes-discovery.module'
import snykdiscovery from './modules/agents/snyk-discovery.module'
import customFilters from './modules/custom-filters/custom-filters.module'
import {
  integrations,
  awsIntegrationSettings,
  azureIntegrationSettings,
  gcpIntegrationSettings,
  carbonblackIntegrationConfig,
  panIntegrationConfig,
  snykIntegrationConfig,
  kubernetesIntegrationConfig,
  guarddutyIntegrationConfig,
  trendmicroIntegrationConfig,
  awslbIntegrationConfig,
  logstashPortsConfig,
  rdsIntegrationConfig,
  cloudtrailIntegrationConfig,
  devoIntegrationConfig,
  historicalCloudtrailIntegrationConfig,
  azureLogIntegrationConfig
} from './modules/integrations'
import anomalies from './modules/anomalies/anomalies.module'
import alertIntegrationsAccounts from './modules/integration_accounts/alertintegration-accounts.module'
import cloudIntegrationsAccounts from './modules/integration_accounts/cloudintegration-accounts.module'
import integrationsAccounts from './modules/integration_accounts/integration-accounts.module'
import kubernetesAccounts from './modules/integration_accounts/kubernetes-accounts.module'
import tags from './modules/tags/tags.module'
import jira from './modules/jira/jira-setting.module'
import reports from './modules/reports/sendgrid-reports.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    nav,
    login,
    user,
    users,
    role,
    trails,
    trailDetails,
    trailGraph,
    trailSummary,
    agents,
    lateralmovements,
    trailMigitation,
    rules,
    detections,
    hostname,
    signup,
    onboard,
    networkInfo,
    os,
    privilegedtrail,
    userEmailNotificationPreference,
    trailMovement,
    statistics,
    hostmapTopolopy,
    notification,
    smtp,
    idp,
    slack,
    jira,
    columnPreference,
    slackNotify,
    mitreAttack,
    processLineage,
    userPref,
    systemPref,
    insightStatistics,
    dnsStatistics,
    externalIpStatistics,
    privilegedExecStatistics,
    loginFailuresStatistics,
    daterangePref,
    traildetections,
    featureEnabled,
    threatHuntingQuerySearchFields,
    threatHuntingQuerySearch,
    savedSearch,
    dashboardKpi,
    version,
    eventsConsumed,
    trailStatistics,
    containerListInfo,
    hostEventComposition,
    mostActive,
    trailsinfoFingerprint,
    allowlist,
    eventTypeValues,
    clouddiscovery,
    kubernetesdiscovery,
    snykdiscovery,
    integrations,
    awsIntegrationSettings,
    azureIntegrationSettings,
    gcpIntegrationSettings,
    carbonblackIntegrationConfig,
    devoIntegrationConfig,
    panIntegrationConfig,
    snykIntegrationConfig,
    kubernetesIntegrationConfig,
    guarddutyIntegrationConfig,
    trendmicroIntegrationConfig,
    awslbIntegrationConfig,
    anomalies,
    alertIntegrationsAccounts,
    cloudIntegrationsAccounts,
    integrationsAccounts,
    accountKeyDetections,
    accountkeyProgressions,
    kubernetesAccounts,
    accountKeyAgents,
    accountKeyContainers,
    logstashPortsConfig,
    rdsIntegrationConfig,
    cloudtrailIntegrationConfig,
    historicalCloudtrailIntegrationConfig,
    azureLogIntegrationConfig,
    tags,
    containerImagesList,
    customFilters,
    reports
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js